class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('DOMContentLoaded', function () {
  async function removeLinkedUpsells() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Get main product variant IDs (items without _linked_to)
      const mainProductIds = cart.items
        .filter((item) => !item.properties?._linked_to)
        .map((item) => item.variant_id.toString().trim());

      let upsellRemoved = false;

      for (const item of cart.items) {
        const linkedTo = item.properties?._linked_to?.toString().trim();
        if (linkedTo && !mainProductIds.includes(linkedTo)) {
          console.log('Removing upsell:', item.title, 'linked to', linkedTo);
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
          upsellRemoved = true;
        }
      }

      if (upsellRemoved) {
        refreshCartDrawer();
      }
    } catch (err) {
      console.error('Error removing linked upsells:', err);
    }
  }

  async function refreshCartDrawer() {
    const cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;
    const drawerRes = await fetch('/cart?sections=cart-drawer');
    const drawerHTML = await drawerRes.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(drawerHTML, 'text/html');
    const newDrawer = doc.querySelector('#CartDrawer');

    if (newDrawer && cartDrawer) {
      cartDrawer.innerHTML = newDrawer.innerHTML;

      // Step 3: Rebind remove buttons
      cartDrawer.querySelectorAll('[data-cart-remove]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const key = e.currentTarget.dataset.cartRemove;
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          removeLinkedUpsells(); // re-run upsell cleanup
        });
      });

      // Optional: rebind quantity buttons, if needed
      // ... add your Dawn quantity rebind logic here
    }
  }


  document.addEventListener('cart:updated', removeLinkedUpsells);

  removeLinkedUpsells();

  const cartContainer = document.querySelector('.cart-drawer, .cart-items');
  if (cartContainer) {
    const observer = new MutationObserver(() => removeLinkedUpsells());
    observer.observe(cartContainer, { childList: true, subtree: true });
  }
});




